import { defineComponent as _defineComponent } from 'vue'
import { customersService } from '@/services/tenants.service';
import { Customer } from '@/models/tenant';
import CustomerForm from '@/components/customers/CustomerForm.vue';
import { reactive, ref } from 'vue';
import { useI18n } from '@/composables/i18n';
import useVuelidate from '@vuelidate/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerCreationModal',
  emits: ['save', 'close'],
  setup(__props, { emit }) {



const { t } = useI18n();

const customer = reactive(Customer.GetEmpty());
const isSubmitting = ref(false);
const v$ = useVuelidate();

async function onSubmit() {
  isSubmitting.value = true;
  customersService
    .create(customer)
    .then(() => {
      emit('save');
      emit('close');
    })
    .finally(() => (isSubmitting.value = false));
}

return { __sfc: true,emit, t, customer, isSubmitting, v$, onSubmit, CustomerForm }
}

})